import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/projects.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";

function Projects() {
    const [usersData, setUsersData] = useState(null);
    const [projectLists, setProjectLists] = useState([]);
    const config = configModule.config();

    const getProjectData = async () => {

        try {
            const response = await axios.get(
                `${config.apiBaseUrl}/get-allprojectlists`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = response.data?.data;
            setProjectLists(data);

        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Something went wrong";

            toast.error(message);
        }
    };

    useEffect(() => {
        if (usersData?.id) {
            getProjectData();
        }
    }, [usersData]);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            const decoded = jwtDecode(token);
            setUsersData(decoded);
        }
    }, []);

    return (
        <div className='dashboardmain-st'>
            <Header pageName="Projects" />
            <div className="body-dashboard">
                <div className="page-header">
                    <div className="page-eyebrow">Explore</div>
                    <div className="page-title">All Projects</div>
                </div>

                <div className="lxp-project-grid">
                    {projectLists?.length > 0 && projectLists.map((item, index) => (
                        <div className="lxp-project-card" key={index}>
                            <div className="lxp-project-img">
                                <span className={`lxp-project-tag ${item?.status === 'Active' ? 'green' : (
                                    item?.status === 'Upcoming' ? 'yellow' : 'red'
                                )} `}>{item?.status}</span>
                            </div>
                            <div className="lxp-project-body">
                                <div className="lxp-project-name">{item?.property_name}</div>
                                <div className="lxp-project-loc">{item?.description}</div>
                                <div className="lxp-project-loc">
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth="1">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                    </svg>
                                    {item?.location}
                                </div>
                                <div className="lxp-project-meta">
                                    <div className='d-center flex-column'>
                                        <div className="lxp-project-meta-label">Type</div>
                                        <div className="lxp-project-meta-val">{item?.property_type}</div>
                                    </div>
                                    <div className='d-center flex-column'>
                                        <div className="lxp-project-meta-label">Phase</div>
                                        <div className="lxp-project-meta-val">{item?.phase}</div>
                                    </div>
                                    <div className='d-center flex-column'>
                                        <div className="lxp-project-meta-label">Inv Amount %</div>
                                        <div className="lxp-project-meta-val">{item?.interest_rate}%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: "#0a1628",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "14px 18px",
                    },
                    success: {
                        iconTheme: {
                            primary: "#22c55e",
                            secondary: "#fff",
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: "#ef4444",
                            secondary: "#fff",
                        },
                    },
                }}
            />
        </div>
    )
}

export default Projects;
